import {Injectable} from '@angular/core';
import {HttpService} from "../http/http.service";
import {catchError, map, Observable} from "rxjs";
import {Payment, ShippingOption} from "../../models/payment/paymentOrder.model";
import {PageEvent} from "@angular/material/paginator";


@Injectable({
	providedIn: 'root'
})
export class PaymentService extends HttpService {
	confirmOrder(payload: any, hash: string): Observable<any> {
		return this.post('orders/confirm?hash=' + hash, payload).pipe(
			map((response: any) => {
				return response;
			}),
			catchError(error => {
				throw error
			})
		)
	}

	getPaymentOrderByHash(hash: string): Observable<Payment> {
		return this.get('payments/' + hash).pipe(
			map((response: any) => {
				return response.data;
			}),
			catchError(error => {
				throw error
			})
		)
	}

	startPaymentProcess(orderHash: string, shippingMethod: ShippingOption, paymentMethod: string): Observable<Payment> {
		const query = {
			shippingMethod: shippingMethod ? shippingMethod.id : undefined,
			method: paymentMethod
		}
		return this.post('payments/' + orderHash, {}, query).pipe(
			map((response: any) => {
				return response.data
			}),
			catchError(error => {
				throw error
			})
		)
	}

	getPaymentsByUser(event?: PageEvent): Observable<Payment[]> {
		let queryParams;
		if (event) {
			queryParams = {
				page: event.pageIndex + 1,
				page_size: event.pageSize,
				status: 'pending,paid'
			}
		} else {
			queryParams = {
				page: 1,
				page_size: 10,
				status: 'pending,paid'
			}
		}

		return this.get('users/payments', queryParams).pipe(
			map((response: any) => {
				return response;
			}),
			catchError(error => {
				throw error
			})
		)
	}

	confirmPayPal(token: string): Observable<any> {
		const reqBody = {
			event_type: "CHECKOUT.ORDER.APPROVED",
			resource: {
				links: [
					{
						href: "https://api.paypal.com/v2/checkout/orders/" + token + "/capture",
						rel: "capture",
						method: "POST"
					}
				],
				id: token,
				status: "approved"
			},
		}

		return this.post('payments/webhook/paypal', reqBody).pipe(
			map((response: any) => {
				return response;
			}),
			catchError(error => {
				throw error
			})
		)
	}
}
